'use strict';

const Enum = require('./enum');

const ChimeVersions = Object.create(Enum, {
  V1: { value: 'chime_version_1', enumerable: true },
  UNKNOWN: { value: 'unknown', enumerable: true },
  parseType: {
    value: function (chimeType) {
      switch (chimeType) {
        case 1:
          return this.V1;
        default:
          return this.UNKNOWN;
      }
    },
    enumerable: false,
  },
  toType: {
    value: function (chimeVersion) {
      switch (chimeVersion) {
        case this.V1:
          return 1;
        default:
          return -1; // unknown
      }
    },
    enumerable: false,
  },
  getVersionFromChimeObject: {
    value: function (chime = {}) {
      if (chime.type) {
        return this.parseType(chime.type);
      }

      const serialNumber = chime.serialNumber || '';
      switch (true) {
        case serialNumber.toUpperCase().startsWith('W'):
          // NOTE for now all chimes produced (W1, W2) are of type 1
          //  need to add differentiation depending on the digit following the W once needed
          return this.V1;
        default:
          return this.UNKNOWN;
      }
    },
    enumerable: false,
  },
});

module.exports.ChimeVersions = ChimeVersions;
module.exports.CHIME_DEFAULT_SETTINGS_ID = '0';

exports.ChimeSettingActions = Object.create(Enum, {
  REBOOT_DOORBELL: { value: 'reboot_doorbell', enumerable: true },
  SEND_SETTINGS_TO_DOORBELL: { value: 'send_settings_to_doorbell', enumerable: true },
});
